// DESCRIPTION: Predefined visual template presets for the post form block.
// Each entry maps block attribute names to preset values.

export const TEMPLATES = [
    {
        id: 'default',
        label: 'Default',
        description: 'Clean, inherits theme styles',
        preview: {
            bg: '#ffffff',
            border: '#dddddd',
            button: '#0073aa',
            text: '#333333',
        },
        attributes: {
            activeTemplate:        'default',
            style: {
                color: {},
            },
            labelFontSize:         '14px',
            labelColor:            '#333333',
            labelFontWeight:       'normal',
            labelFontFamily:       '',
            labelFontStyle:        '',
            helpTextColor:         '#767676',
            helpTextFontFamily:    '',
            helpTextFontSize:      '12px',
            helpTextFontStyle:     '',
            helpTextFontWeight:    '',
            fieldBorder: {
                color: '#dddddd',
                style: 'solid',
                width: '1px',
            },
            fieldBorderRadius:     '4px',
            fieldPaddingV:         '8px',
            fieldPaddingH:         '12px',
            fieldBackgroundColor:  '#ffffff',
            fieldTextColor:        '#333333',
            fieldPlaceholderColor: '#aaaaaa',
            fieldFontFamily:       '',
            fieldFontSize:         '14px',
            fieldFontStyle:        '',
            fieldFontWeight:       '',
            fieldMarginBottom:     '16px',
            fieldFocusBorderColor: '#0073aa',
            buttonBackgroundColor: '#0073aa',
            buttonTextColor:       '#ffffff',
            buttonBorderColor:     '',
            buttonBorderWidth:     '0px',
            buttonBorderRadius:    '4px',
            buttonFontSize:        '14px',
            buttonFontFamily:      '',
            buttonFontStyle:       '',
            buttonFontWeight:      '',
            buttonPaddingV:        '10px',
            buttonPaddingH:        '20px',
            uploadButtonBackgroundColor: '#f0f0f0',
            uploadButtonTextColor:      '#333333',
            uploadButtonBorderColor:    '#dddddd',
            uploadButtonBorderWidth:    '1px',
            uploadButtonBorderRadius:   '4px',
            uploadButtonFontSize:       '13px',
            uploadButtonFontFamily: '',
            uploadButtonFontStyle:  '',
            uploadButtonFontWeight: '',
            uploadButtonPaddingV:       '8px',
            uploadButtonPaddingH:       '16px',
            errorMessageColor:     '#cc0000',
            successMessageColor:   '#00a32a',
        },
    },
    {
        id: 'dark',
        label: 'Dark',
        description: 'Dark background, light text',
        preview: {
            bg: '#1e1e2e',
            border: '#3d3d5c',
            button: '#7c3aed',
            text: '#f0f0f0',
        },
        attributes: {
            activeTemplate:        'dark',
            style: {
                color: {
                    background: '#1e1e2e',
                },
            },
            labelFontSize:         '14px',
            labelColor:            '#e0e0e0',
            labelFontWeight:       'normal',
            labelFontFamily:       '',
            labelFontStyle:        '',
            helpTextColor:         '#a0a0b0',
            helpTextFontFamily:    '',
            helpTextFontSize:      '12px',
            helpTextFontStyle:     '',
            helpTextFontWeight:    '',
            fieldBorder: {
                color: '#3d3d5c',
                style: 'solid',
                width: '1px',
            },
            fieldBorderRadius:     '6px',
            fieldPaddingV:         '10px',
            fieldPaddingH:         '14px',
            fieldBackgroundColor:  '#2a2a3e',
            fieldTextColor:        '#f0f0f0',
            fieldPlaceholderColor: '#6b6b8a',
            fieldFontFamily:       '',
            fieldFontSize:         '14px',
            fieldFontStyle:        '',
            fieldFontWeight:       '',
            fieldMarginBottom:     '18px',
            fieldFocusBorderColor: '#7c3aed',
            buttonBackgroundColor: '#7c3aed',
            buttonTextColor:       '#ffffff',
            buttonBorderColor:     '',
            buttonBorderWidth:     '0px',
            buttonBorderRadius:    '6px',
            buttonFontSize:        '14px',
            buttonFontFamily:      '',
            buttonFontStyle:       '',
            buttonFontWeight:      '',
            buttonPaddingV:        '12px',
            buttonPaddingH:        '24px',
            uploadButtonBackgroundColor: '#2a2a3e',
            uploadButtonTextColor:      '#e0e0e0',
            uploadButtonBorderColor:    '#3d3d5c',
            uploadButtonBorderWidth:    '1px',
            uploadButtonBorderRadius:   '6px',
            uploadButtonFontSize:       '13px',
            uploadButtonFontFamily: '',
            uploadButtonFontStyle:  '',
            uploadButtonFontWeight: '',
            uploadButtonPaddingV:       '8px',
            uploadButtonPaddingH:       '16px',
            errorMessageColor:     '#f87171',
            successMessageColor:   '#34d399',
        },
    },
    {
        id: 'colorful',
        label: 'Colorful',
        description: 'Vibrant purple accent',
        preview: {
            bg: '#fdf4ff',
            border: '#c084fc',
            button: '#9333ea',
            text: '#4a044e',
        },
        attributes: {
            activeTemplate:        'colorful',
            style: {
                color: {},
            },
            labelFontSize:         '14px',
            labelColor:            '#7e22ce',
            labelFontWeight:       '600',
            labelFontFamily:       '',
            labelFontStyle:        '',
            helpTextColor:         '#a855f7',
            helpTextFontFamily:    '',
            helpTextFontSize:      '12px',
            helpTextFontStyle:     '',
            helpTextFontWeight:    '',
            fieldBorder: {
                color: '#c084fc',
                style: 'solid',
                width: '2px',
            },
            fieldBorderRadius:     '8px',
            fieldPaddingV:         '10px',
            fieldPaddingH:         '14px',
            fieldBackgroundColor:  '#fdf4ff',
            fieldTextColor:        '#4a044e',
            fieldPlaceholderColor: '#d8b4fe',
            fieldFontFamily:       '',
            fieldFontSize:         '14px',
            fieldFontStyle:        '',
            fieldFontWeight:       '',
            fieldMarginBottom:     '20px',
            fieldFocusBorderColor: '#7e22ce',
            buttonBackgroundColor: '#9333ea',
            buttonTextColor:       '#ffffff',
            buttonBorderColor:     '',
            buttonBorderWidth:     '0px',
            buttonBorderRadius:    '8px',
            buttonFontSize:        '15px',
            buttonFontFamily:      '',
            buttonFontStyle:       '',
            buttonFontWeight:      '',
            buttonPaddingV:        '12px',
            buttonPaddingH:        '28px',
            uploadButtonBackgroundColor: '#f3e8ff',
            uploadButtonTextColor:      '#7e22ce',
            uploadButtonBorderColor:    '#c084fc',
            uploadButtonBorderWidth:    '2px',
            uploadButtonBorderRadius:   '8px',
            uploadButtonFontSize:       '13px',
            uploadButtonFontFamily: '',
            uploadButtonFontStyle:  '',
            uploadButtonFontWeight: '',
            uploadButtonPaddingV:       '8px',
            uploadButtonPaddingH:       '16px',
            errorMessageColor:     '#be123c',
            successMessageColor:   '#16a34a',
        },
    },
    {
        id: 'minimal',
        label: 'Minimal',
        description: 'Borderless fields, understated',
        preview: {
            bg: '#ffffff',
            border: '#e5e5e5',
            button: '#111111',
            text: '#111111',
        },
        attributes: {
            activeTemplate:        'minimal',
            style: {
                color: {},
            },
            labelFontSize:         '13px',
            labelColor:            '#555555',
            labelFontWeight:       'normal',
            labelFontFamily:       '',
            labelFontStyle:        '',
            helpTextColor:         '#999999',
            helpTextFontFamily:    '',
            helpTextFontSize:      '11px',
            helpTextFontStyle:     '',
            helpTextFontWeight:    '',
            fieldBorder: {
                color: '#dddddd',
                style: 'solid',
                width: '1px',
            },
            fieldBorderRadius:     '0px',
            fieldPaddingV:         '8px',
            fieldPaddingH:         '4px',
            fieldBackgroundColor:  '#ffffff',
            fieldTextColor:        '#111111',
            fieldPlaceholderColor: '#cccccc',
            fieldFontFamily:       '',
            fieldFontSize:         '13px',
            fieldFontStyle:        '',
            fieldFontWeight:       '',
            fieldMarginBottom:     '20px',
            fieldFocusBorderColor: '#111111',
            buttonBackgroundColor: '#111111',
            buttonTextColor:       '#ffffff',
            buttonBorderColor:     '',
            buttonBorderWidth:     '0px',
            buttonBorderRadius:    '2px',
            buttonFontSize:        '13px',
            buttonFontFamily:      '',
            buttonFontStyle:       '',
            buttonFontWeight:      '',
            buttonPaddingV:        '10px',
            buttonPaddingH:        '24px',
            uploadButtonBackgroundColor: '#ffffff',
            uploadButtonTextColor:      '#555555',
            uploadButtonBorderColor:    '#e5e5e5',
            uploadButtonBorderWidth:    '0px',
            uploadButtonBorderRadius:   '0px',
            uploadButtonFontSize:       '13px',
            uploadButtonFontFamily: '',
            uploadButtonFontStyle:  '',
            uploadButtonFontWeight: '',
            uploadButtonPaddingV:       '8px',
            uploadButtonPaddingH:       '4px',
            errorMessageColor:     '#cc0000',
            successMessageColor:   '#008000',
        },
    },
    {
        id: 'bold',
        label: 'Bold',
        description: 'Strong borders, high contrast',
        preview: {
            bg: '#ffffff',
            border: '#000000',
            button: '#f59e0b',
            text: '#000000',
        },
        attributes: {
            activeTemplate:        'bold',
            style: {
                color: {},
            },
            labelFontSize:         '15px',
            labelColor:            '#000000',
            labelFontWeight:       '700',
            labelFontFamily:       '',
            labelFontStyle:        '',
            helpTextColor:         '#555555',
            helpTextFontFamily:    '',
            helpTextFontSize:      '13px',
            helpTextFontStyle:     '',
            helpTextFontWeight:    '',
            fieldBorder: {
                color: '#000000',
                style: 'solid',
                width: '2px',
            },
            fieldBorderRadius:     '0px',
            fieldPaddingV:         '10px',
            fieldPaddingH:         '14px',
            fieldBackgroundColor:  '#ffffff',
            fieldTextColor:        '#000000',
            fieldPlaceholderColor: '#999999',
            fieldFontFamily:       '',
            fieldFontSize:         '15px',
            fieldFontStyle:        '',
            fieldFontWeight:       '',
            fieldMarginBottom:     '20px',
            fieldFocusBorderColor: '#f59e0b',
            buttonBackgroundColor: '#f59e0b',
            buttonTextColor:       '#000000',
            buttonBorderColor:     '#000000',
            buttonBorderWidth:     '2px',
            buttonBorderRadius:    '0px',
            buttonFontSize:        '15px',
            buttonFontFamily:      '',
            buttonFontStyle:       '',
            buttonFontWeight:      '',
            buttonPaddingV:        '12px',
            buttonPaddingH:        '28px',
            uploadButtonBackgroundColor: '#ffffff',
            uploadButtonTextColor:      '#000000',
            uploadButtonBorderColor:    '#000000',
            uploadButtonBorderWidth:    '2px',
            uploadButtonBorderRadius:   '0px',
            uploadButtonFontSize:       '13px',
            uploadButtonFontFamily: '',
            uploadButtonFontStyle:  '',
            uploadButtonFontWeight: '',
            uploadButtonPaddingV:       '8px',
            uploadButtonPaddingH:       '16px',
            errorMessageColor:     '#cc0000',
            successMessageColor:   '#166534',
        },
    },
];
